import { FETCH_DEMO_MODE_BANNER_ASYNC } from './constants'

export const fetchDemoBannerStatusSuccess = (data) => ({
  type: FETCH_DEMO_MODE_BANNER_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDemoBannerStatusError = (error) => ({
  type: FETCH_DEMO_MODE_BANNER_ASYNC.ERROR,
  error,
})
